import {createApp} from 'vue'
import Store from 'store'
import TableComponentGeneric from './TableComponentGeneric'

const component = createApp(TableComponentGeneric).use(Store)

const el = '.nlx-component--table-component-generic'
const DOM = document.querySelector(el)

if(DOM){
    component.mount(el)
}

